import { useState } from 'react'

export const useModalSharePublicURL = () => {
  const [isOpenModalSharePublicURL, setIsOpenModalSharePublicURL] = useState(false)

  const onCloseModalSharePublicURL = () => setIsOpenModalSharePublicURL(false)

  return {
    isOpenModalSharePublicURL,
    setIsOpenModalSharePublicURL,
    onCloseModalSharePublicURL
  }
}
